<script lang="ts">
	import { onMount } from 'svelte';
	import { width } from '$lib/store';
	import type { PostAttrsArray } from '$lib/posts/post.type';
	// PostAttrs,
	import Article from '$lib/components/blog/article/Article.svelte';
	import ArticleTitle from '$lib/components/blog/article/ArticleTitle.svelte';
	import AuthorInfo from './article/AuthorInfo.svelte';
	// import ArticleLocation from '$lib/components/blog/article/ArticleLocation.svelte';
	import ArticleFeaturedImagePublic from '$lib/components/blog/article/ArticleFeaturedImagePublic.svelte';
	// import { afterUpdate } from 'svelte';
	import Triangle from '../syllabus/triangle.svelte';

	// export let topic;
	// export let description = '';
	export let posts: PostAttrsArray;
	let borderClass: string = 'rounded-b-2xl';

	// let limit = false;
	// let cardColor;
	let visible = false;

	const handleOnResize = () => {
		visible = true;
	};

	// const getPosts = (numPosts: number) => {
	// 	// console.log('numPosts', numPosts);
	// 	posts = allPosts.sort().slice(0, numPosts);
	// 	// console.log('Length', posts.length);
	// };

	const options: Intl.DateTimeFormatOptions = {
		month: 'long',
		day: 'numeric'
	};

	onMount(() => {
		// console.log('RenderCardsUnderPost: onMount');
		handleOnResize();
	});
</script>

<svelte:window on:resize={handleOnResize} bind:innerWidth={$width} />

<div class="">
	<div
		class="scrollable-container flex flex-no-wrap overflow-x-scroll justify-start scrolling-touch items-start mb-6 pb-4 2xl:w-5/6 2xl:mx-auto"
	>
		{#if visible}
			<!-- <div class="flex flex-wrap gap-4 xl:gap-6 justify-center md:-mx-16 xl:mx-0"> -->
			<!--TODO: refactor to each posts as post... use postStore-->
			{#each posts as { slug, title, author, location, image_url, description, created_by, event_date_start, event_date_end, event_location, impacts }}
				<li class="flex-none list-none">
					<div
						class="
            rounded-2xl drop-shadow-lg shadow-bloomPurpleDarkActive
    border-2 border-cosmicMagenta400
    bg-cosmicPurplebg w-64 md:w-72 mx-1 xs:mx-2
        "
					>
						<!-- Card-->
						<Article {slug} {title}>
							<article
								class="relative break-inside w-64 md:w-72 pt-2 md:pt-3 rounded-2xl bg-cosmicPurplebg flex flex-col"
							>
								<div class="relative h-40 lg:h-48 px-2 md:px-4">
									<div class="px-2 md:px-4">
										<AuthorInfo {location} {created_by} {author} />
									</div>
									<div class="h-16 md:mb-1 line-clamp-2 text-left">
										<ArticleTitle {slug} {title} />
									</div>
									<p
										class="text-cosmicPurple100 text-left mb-4 text-sm md:text-base line-clamp-2 lg:line-clamp-3 font-sans"
									>
										{#if impacts}
											Results: <span>
												{#each impacts.slice(0, 2) as _impact, index}
													{_impact.text}{#if index < Math.min(impacts.length, 2) - 1};&nbsp;
													{/if}
												{/each}
												{#if impacts.length > 2}...{/if}</span
											>
										{:else if event_date_start}
											<div>
												{new Date(event_date_start).toLocaleDateString('en-US', options)} - {new Date(
													event_date_end
												).toLocaleDateString('en-US', options)}
											</div>
											{event_location}
										{:else}
											{description}
										{/if}
									</p>
									<div class="absolute bottom-0 right-4 flex">
										<!-- <div class="ml-2 -rotate-90 outline-2 outline-bloomGreenDark scale-90"><Triangle /></div> -->
									</div>
								</div>

								<div class="flex gap-1 w-full mx-auto text-center mt-3">
									<div class="flex-grow">
										<div class="h-full flex flex-col-reverse">
											<div class="flex">
												<ArticleFeaturedImagePublic {image_url} alt={'...'} {borderClass} />
											</div>
										</div>
									</div>
								</div>
							</article></Article
						>
					</div>

					<slot />
				</li>
			{/each}
			<!-- </div> -->

			<slot />
		{/if}
	</div>
</div>
<div class="flex mx-auto gap-5 justify-center">
	<div class="rotate-90">
		<Triangle />
	</div>
	<div class="-rotate-90">
		<Triangle />
	</div>
</div>
<div class="lg:hidden font-exo-2 text-gradientBlue text-center text-base font-bold mt-2">
	Swipe to see more
</div>
<div class="hidden lg:block font-exo-2 text-gradientBlue text-center text-base font-bold mt-2">
	Scroll to see more
</div>

<!-- body {
	scrollbar-width: thin;
	scrollbar-color: #261942 #392373; /* Adjust colors as needed */
} -->

<style>
	.scrollable-container::-webkit-scrollbar {
		width: 16px; /* Increase width for better visibility */
		height: 16px; /* For horizontal scrollbars */
	}

	.scrollable-container::-webkit-scrollbar-thumb {
		background-color: #392373; /* Adjust color as needed */
		border-radius: 6px;
	}

	.scrollable-container::-webkit-scrollbar-track {
		background-color: #261942; /* Adjust color as needed */
		border-radius: 6px;
	}

	/* Define scrollbar width and color for Firefox */
	.scrollable-container {
		scrollbar-width: thin; /* Default for Firefox */
		scrollbar-color: #392373 #261942; /* Adjust colors as needed */
	}
	/* Define scrollbar width and color for Firefox */
	/* Firefox supports scrollbar styling using the scrollbar-color property */
	/* You need to apply these styles to a specific container */
	/* In this example, we apply it to the body */
</style>
